import React from 'react';
import { Points } from 'components/Points/Points';
import './ReceivingSummary.css';

interface SummaryStats {
  preparing: number;
  transit: number;
  completed: number;
  totalPoints: number;
}

interface Props {
  stats: SummaryStats;
}

export default function ReceivingSummary({ stats }: Props) {
  return (
    <div className="receiving-summary">
      <div className="summary-card">
        <div className="summary-number">{stats.preparing}</div>
        <div className="summary-label">Preparing to ship</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-number">{stats.transit}</div>
        <div className="summary-label">In Transit</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-number">{stats.completed}</div>
        <div className="summary-label">Completed</div>
      </div>
      
      <div className="summary-card points-card">
        <Points points={stats.totalPoints} type="big" />
        <div className="summary-label">Inbound trades</div>
      </div>
    </div>
  );
}